"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ApolloProvider", {
  enumerable: true,
  get: function get() {
    return _reactApollo.ApolloProvider;
  }
});
exports.client = exports.CANCEL_QUERY_MESSAGE = void 0;
Object.defineProperty(exports, "gql", {
  enumerable: true,
  get: function get() {
    return _apolloBoost.gql;
  }
});
Object.defineProperty(exports, "graphql", {
  enumerable: true,
  get: function get() {
    return _reactApollo.graphql;
  }
});
exports.taskMasterClient = void 0;
Object.defineProperty(exports, "useGraphqlData", {
  enumerable: true,
  get: function get() {
    return _useGraphqlData["default"];
  }
});
Object.defineProperty(exports, "withApollo", {
  enumerable: true,
  get: function get() {
    return _reactApollo.withApollo;
  }
});
var _apolloBoost = require("apollo-boost");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _store = _interopRequireDefault(require("store"));
var _timezone = _interopRequireDefault(require("./timezone.js"));
var _reactApollo = require("react-apollo");
var _useGraphqlData = _interopRequireDefault(require("./useGraphqlData.js"));
var _window, _window$cccisd, _window$cccisd$env;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var uri = Boilerplate && Boilerplate.url ? Boilerplate.url('/graphql') : '/graphql';
var cache = new _apolloBoost.InMemoryCache();
var tzHeaders = {
  'X-Cccisd-Timezone': (0, _timezone["default"])()
};
var httpLink = new _apolloBoost.HttpLink({
  uri: uri
});
var onError = function onError(_ref) {
  var graphQLErrors = _ref.graphQLErrors,
    networkError = _ref.networkError;
  if (networkError) {
    if (networkError.statusCode === 401) {
      _store["default"].set('cccisd_logout_message', "You've been logged out");
      _store["default"].set('cccisd_logout_url', window.location.href);
      _store["default"].set('cccisd_logout_time', Date.now());
      window.location = Boilerplate.url('account/login');
    } else if (networkError.statusCode === 403) {
      window.location = Boilerplate.url('authRedirect');
    } else if (networkError.statusCode === 500) {
      (0, _cccisdNotification["default"])({
        message: '500: Server Error',
        type: 'danger',
        duration: 0
      });
    } else if (networkError.statusCode === 504) {
      (0, _cccisdNotification["default"])({
        message: '504: Network Error',
        type: 'danger',
        duration: 0
      });
    } else {
      (0, _cccisdNotification["default"])({
        message: networkError.message,
        type: 'danger',
        duration: 0
      });
    }
    return;
  }
  if (graphQLErrors) {
    (0, _cccisdNotification["default"])({
      message: graphQLErrors.map(function (error) {
        return error.message;
      }).join(' '),
      type: 'danger',
      duration: 0
    });
  }
};
var client = exports.client = new _apolloBoost.ApolloClient({
  link: httpLink,
  cache: cache,
  onError: onError
});
var currentCount = 0;
var MAX_CONNECTIONS = ((_window = window) === null || _window === void 0 ? void 0 : (_window$cccisd = _window.cccisd) === null || _window$cccisd === void 0 ? void 0 : (_window$cccisd$env = _window$cccisd.env) === null || _window$cccisd$env === void 0 ? void 0 : _window$cccisd$env.maxApolloConnections) || 2; // Max number of parallel queries
var CANCEL_QUERY_MESSAGE = exports.CANCEL_QUERY_MESSAGE = 'The query is canceled';
var queryTokens = {};

// Adjust query to allow only MAX_CONNECTIONS queries
var getAdjustedQuery = function getAdjustedQuery(originalQuery) {
  return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _len,
      params,
      _key,
      cancelTag,
      currentQueryTokens,
      _iterator,
      _step,
      tag,
      result,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = _args[_key];
          }
          // convert params to object if it's just query
          if (!params[0].query) {
            params = [{
              query: params[0]
            }];
          }
          cancelTag = params[0].cancelTag;
          if (typeof cancelTag === 'string') {
            cancelTag = [cancelTag];
          }
          currentQueryTokens = {};
          if (cancelTag) {
            _iterator = _createForOfIteratorHelper(cancelTag);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                tag = _step.value;
                if (!queryTokens[tag]) {
                  queryTokens[tag] = {};
                }
                currentQueryTokens[tag] = queryTokens[tag];
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          if (!(currentCount >= MAX_CONNECTIONS)) {
            _context.next = 9;
            break;
          }
          _context.next = 9;
          return new Promise(function (resolve, reject) {
            var interval = setInterval(function () {
              if (cancelTag && cancelTag.some(function (tag) {
                return currentQueryTokens[tag] !== queryTokens[tag];
              })) {
                clearInterval(interval);
                reject(new Error(CANCEL_QUERY_MESSAGE));
              }
              if (currentCount < MAX_CONNECTIONS) {
                clearInterval(interval);
                resolve();
              }
            }, 200);
          });
        case 9:
          currentCount++;
          params[0].context = {
            headers: paramsToHeaders(params[0])
          };
          _context.prev = 11;
          _context.next = 14;
          return originalQuery.apply(void 0, _toConsumableArray(params));
        case 14:
          result = _context.sent;
          _context.next = 21;
          break;
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](11);
          // just to decrement currentCount if originalQuery throws an error
          currentCount--;
          throw _context.t0;
        case 21:
          currentCount--;
          if (!(cancelTag && cancelTag.some(function (tag) {
            return currentQueryTokens[tag] !== queryTokens[tag];
          }))) {
            _context.next = 24;
            break;
          }
          throw new Error(CANCEL_QUERY_MESSAGE);
        case 24:
          return _context.abrupt("return", result);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[11, 17]]);
  }));
};
var cancelQueries = function cancelQueries(cancelTag) {
  if (typeof cancelTag === 'string') {
    cancelTag = [cancelTag];
  }
  var _iterator2 = _createForOfIteratorHelper(cancelTag),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var tag = _step2.value;
      queryTokens[tag] = {};
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
client.query = getAdjustedQuery(client.query);
client.cancelQueries = cancelQueries;
var taskMasterUri = Boilerplate && Boilerplate.route ? Boilerplate.route('graphql.querytask') : '/api/graphql/query';
var taskMasterLink = new _apolloBoost.HttpLink({
  fetch: function (_fetch) {
    function fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }
    fetch.toString = function () {
      return _fetch.toString();
    };
    return fetch;
  }(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
      var results, done, timeout, progressOptions, taskUrl, resultsUri, actualResults;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            options.headers = _objectSpread(_objectSpread({}, options.headers), tzHeaders);
            _context2.next = 3;
            return fetch(taskMasterUri, options).then(function (response) {
              return response.json();
            });
          case 3:
            results = _context2.sent;
            done = results.taskProgress.done;
            timeout = results.taskProgress.timeout;
            progressOptions = options;
            taskUrl = results.taskProgress.taskUrl;
            progressOptions.method = 'GET';
            progressOptions.body = undefined;
          case 10:
            if (done) {
              _context2.next = 19;
              break;
            }
            _context2.next = 13;
            return new Promise(function (r) {
              return setTimeout(r, timeout);
            });
          case 13:
            _context2.next = 15;
            return fetch(taskUrl, progressOptions).then(function (response) {
              return response.json();
            });
          case 15:
            results = _context2.sent;
            done = results.taskProgress.done;
            _context2.next = 10;
            break;
          case 19:
            resultsUri = results.taskProgress.results.url;
            _context2.next = 22;
            return fetch(resultsUri, options);
          case 22:
            actualResults = _context2.sent;
            return _context2.abrupt("return", actualResults);
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }())
});
var paramsToHeaders = function paramsToHeaders(params) {
  var headers = {};
  if (typeof params.cccisdReadReplica !== 'undefined') {
    headers['X-Cccisd-Read-Replica'] = params.cccisdReadReplica;
  }
  if (typeof params.cccisdCacheContext !== 'undefined') {
    headers['X-Cccisd-Cache-Context'] = params.cccisdCacheContext;
  }
  if (typeof params.cccisdMaxAge !== 'undefined') {
    headers['X-Cccisd-Max-Age'] = params.cccisdMaxAge;
  }
  if (typeof params.cccisdTimezone !== 'undefined') {
    headers['X-Cccisd-Timezone'] = params.cccisdTimezone;
  } else {
    headers['X-Cccisd-Timezone'] = tzHeaders['X-Cccisd-Timezone'];
  }
  return headers;
};
var taskMasterClient = exports.taskMasterClient = new _apolloBoost.ApolloClient({
  link: taskMasterLink,
  cache: cache,
  onError: onError
});
taskMasterClient.query = getAdjustedQuery(taskMasterClient.query);
taskMasterClient.cancelQueries = cancelQueries;